<template>
    <div class="inline-block custom-filter">
        <ESelect
            :size="size"
            :value="value"
            @visible-change="visibleChange"
            @change="handleChange"
            :loading="loading"
            :remote-method="remoteMethod"
            :clearable="clearable"
            :collapse-tags="collapseTags"
            :reserve-keyword="reserveKeyword"
            remote
            multiple
            filterable
            :placeholder="placeholder"
            :class="collapseTags?'remote-select-tags-width':''"
            popper-class="virtual_no_scroll select-option-long-text-wrap"
            :style="{width: inputWidth+'px'}">
            <el-option value="all-option" v-if="(options||[]).length>0&&!optionsAllChecked">全选</el-option>
            <el-option value="clear-option" v-if="(options||[]).length>0&&optionsAllChecked">取消全选</el-option>
            <virtual-list
            ref="refVirList"
            class="virtualselect-list"
            style="max-height: 200px; overflow-y: auto;"
            :data-key="'value'"
            :data-sources="datasources"
            :data-component="itemComponent"
            :estimate-size="50"
            >

            </virtual-list>


        </ESelect>
        <el-tooltip class="item" effect="dark" content="批量筛选" placement="top">
            <el-button :size="size" class="pl9 pr9 action-btn" @click="showBatchModal"> <span class="copy-btn-icon el-icon-document-copy"></span></el-button>
        </el-tooltip>

        <el-dialog
            width="520px"
            :title="'批量选择'+title"
            :visible.sync="batchVisible"
            :close-on-click-modal="false"
            :show-close="false"
            class="batch-modal modal-body-padding-top-10"
            append-to-body>
            <div>
                <p class="text-color-gray mb10">{{batchDesc||('输入或粘贴'+title+'，每行一个')}}</p>
                <div class="batch-content">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="batchCon"
                        :rows="10"
                        resize="none"
                        style="min-height: 200px;"
                        :autofocus="true"
                    >
                    </el-input>
                </div>
                <p class="tac mt20">
                    <el-button type="default" @click="hideBatchModal" class="mr20">取消</el-button>
                    <el-button type="primary" @click="submitBatchModal" :loading="batchLoading" class="ml20">提交
                    </el-button>
                </p>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import VirtualList from 'vue-virtual-scroll-list'
    import OptionsItem from './item'
    import { cloneDeep, debounce } from 'lodash'
    import { ESelect } from '@/components/Ele/eSelect';
    export default {
        name: "BatchMultipleSelect",
        components: { 'virtual-list': VirtualList, OptionsItem, ESelect },
        props:{
            placeholder:{
                type:String,
                default:'请输入',
            },
            clearable:{
                type: Boolean,
                default: false,
            },
            reserveKeyword:{
                type: Boolean,
                default: true,
            },
            collapseTags:{
                type: Boolean,
                default: false,
            },
            loading:{
                type: Boolean,
                default: false,
            },
            options:{
                type: Array,
                default: ()=>{
                    return [];
                },
            },
            remoteMethod:{
                type:Function,
                default:()=>{

                },
            },
            value:{
                type: Array,
                default: ()=>{
                    return [];
                },
            },
            title:String,
            batchDesc:{
                type: String,
                default: '',
            },
            size:{
                validator: function (value) {
                    return ['small', 'mini', 'large'].includes(value);
                },
                default: 'small',
            },
            inputWidth:{
                type: Number,
                default: 210,
            },
        },
        data(){
            return {
                batchVisible:false,
                batchCon:'',
                batchLoading:false,
                itemComponent: OptionsItem,
                datasources: [],
                start: 0
            };
        },
        computed:{
            optionsAllChecked(){
                return this.options.map(item=>item.value).every(item=>this.value.includes(item));
            }
        },
        watch: {
            'options'() {
                this.init()
            }
        },
        mounted() {
            // this.init()
        },
        methods:{
            init() {
                if (!this.value || this.value.length === 0) {
                    // 初始化数据
                    this.datasources = this.options;
                    // this.$refs.refVirList.forceUpdate();
                } else {

                    // 回显问题
                    // 单选时，存储当前的index
                    // 多选时，取选中的所有值中下标的最小值
                    this.datasources = cloneDeep(this.options)
                    // this.$refs.refVirList.forceUpdate();
                    // let res_datasources = cloneDeep(this.options)
                    // if (typeof this.value === 'string') {
                    //     const value = this.value
                    //     for (let i = 0; i < res_datasources.length; i++) {
                    //         const element = res_datasources[i];
                    //         if (element['value'] == value) {
                    //         this.start = i
                    //         break;
                    //         }
                    //     }
                    // } else if (Array.isArray(this.value)) {
                    //     let start = []
                    //     const valueSet = new Set(this.value)
                    //     for (let i = 0; i < res_datasources.length; i++) {
                    //         const element = res_datasources[i];
                    //         if (valueSet.has(element['value'])) {
                    //         start.push(i)
                    //         }
                    //     }
                    //     this.start = Math.min(...start)
                    // }
                }
            },
            visibleChange(val){
                if(val){
                    this.$emit('show-options');
                    this.$refs.refVirList.reset();
                }
                // if (!val) {
                //     this.$refs.refVirList.reset();
                //     this.init();
                // } else {
                //     // 定位到选中的位置
                //     console.log('this.start', this.start)
                //     // this.$emit('show-options');
                //     this.$nextTick(() => {
                //         this.$refs.refVirList.scrollToIndex(this.start.toString());
                //     })
                // }
            },
            handleChange(val){
                let checkedList = [];
                if(val.includes('all-option')){
                    checkedList = this.options.map(item=>item.value);
                    this.$emit('change-all',checkedList);
                }else if(val.includes('clear-option')){
                    checkedList = this.options.map(item=>item.value);
                    this.$emit('clear-all',checkedList);
                }else{
                    checkedList = val;
                    this.$emit('change',checkedList);
                }
            },
            showBatchModal(){
                this.batchVisible = true;
            },
            hideBatchModal(){
                this.hideBatchLoading();
                this.batchCon = '';
                this.batchVisible = false;
            },
            submitBatchModal(){
                let batchSearch = this.batchCon.split(/\n/).map(item=>item.trim()).filter(item=>!!item);
                if(batchSearch.length<=0){
                    return this.hideBatchModal();
                }
                this.batchLoading = true;
                this.$emit('batch-submit',batchSearch);
            },
            hideBatchLoading(){
                this.batchLoading = false;
            },
            destroyComponent() {
                // 销毁当前组件
                this.$destroy()
            }
        },
        destroyed() {
            console.log('组件销毁时的处理逻辑');
        }
    }
</script>
<style lang="scss">
.virtualselect {
  // 设置最大高度
  &-list {
    max-height: 245px;
    overflow-y: auto;
  }
}
.virtual_no_scroll{
    .el-scrollbar .el-scrollbar__bar.is-vertical {
    width: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
    .p9{
        padding: 9px;
    }
    .pl9{
        padding-left: 9px;
    }
    .pr9{
        padding-right: 9px;
    }
    .action-btn{
        border-radius: 0;
        border-left: transparent;
    }
    .custom-filter ::v-deep .remote-select-tags-width .el-input .el-input__inner{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
</style>
